import { Button, Typography } from "@flash-tecnologia/hros-web-ui-v2";
import styled, { css, keyframes } from "styled-components";

export const ResponsiveContainer = styled.div`
  height: 100%;
  width: 100%;
  min-height: 0;

  padding: ${({ theme }) => theme.spacings.m} 0;
  display: grid;
  gap: ${({ theme }) => theme.spacings.xs};
  grid-template-columns:
    [full-start] repeat(1, 1fr)
    [content-start] repeat(6, 1fr)
    [content-end] repeat(1, 1fr)
    [full-end];

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(8, 1fr);
  }
`;

export const Grid = styled.div`
  height: 100%;
  min-height: 0;
  max-height: 100%;
  width: 100%;

  display: grid;
  grid-column: content-start / content-end;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  align-items: stretch;
  align-content: stretch;

  gap: ${({ theme }) => theme.spacings.xs4};

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    grid-column: 1 / -1;
    grid-template-columns: repeat(6, 1fr);
  }
`;

export const LeftSection = styled.div`
  grid-column: 1 / span 4;

  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-column: 1 / -1;
  }
`;

export const RightSection = styled.div`
  grid-column: 5 / span 2;

  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-column: 1 / -1;
  }
`;

export const OptionLabel = styled(Typography)`
  flex: 1;
`;

const shake = keyframes`
  0% { transform: translateX(0); }
  20% { transform: translateX(-3px); }
  40% { transform: translateX(3px); }
  60% { transform: translateX(-3px); }
  80% { transform: translateX(3px); }
  100% { transform: translateX(0); }
`;

export const AddMembersButton = styled(Button)<{ shouldShake: boolean }>`
  border-color: ${({ theme }) => theme.colors.secondary[95]} !important;
  background-color: ${({ theme }) => theme.colors.secondary[95]} !important;
  border-radius: ${({ theme }) => theme.borders.radius.pill} !important;
  width: 100% !important;

  &:hover {
    background: ${({ theme }) => theme.colors.secondary[90]} !important;
  }

  ${({ shouldShake }) =>
    shouldShake &&
    css`
      animation: ${shake} 0.4s ease;
    `}
`;
